var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0565 3.1131C17.8336 1.83204 15.8511 1.8321 14.6283 3.11324L4.17203 14.0687C3.81649 14.4413 3.56659 14.9098 3.45013 15.4222L2.49149 19.6402C2.43871 19.8725 2.50471 20.1168 2.66585 20.2856C2.827 20.4544 3.06021 20.5235 3.2819 20.4683L7.30799 19.4641C7.79729 19.3419 8.24466 19.0801 8.6003 18.7074L19.0566 7.7519C20.2793 6.47087 20.2793 4.39405 19.0565 3.1131ZM15.5565 4.08545C16.2666 3.34134 17.4182 3.34131 18.1284 4.08537C18.8386 4.82938 18.8387 6.03564 18.1285 6.77968L17.3486 7.59685L14.7767 4.90245L15.5565 4.08545ZM13.8486 5.87478L16.4206 8.56917L7.67217 17.7352C7.48829 17.9279 7.25698 18.0633 7.00399 18.1264L4.0153 18.8719L4.72694 15.7407C4.78715 15.4757 4.91635 15.2335 5.10016 15.041L13.8486 5.87478Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlack);
export default __webpack_public_path__ + "static/media/pencil-black.89dc20ceed3105742f0fffac0a08ab18.svg";
export { ForwardRef as ReactComponent };